import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/SplashWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/opt/build/repo/src/context/NotificationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/tailwind.css");
